// extracted by mini-css-extract-plugin
module.exports = {"notAvailableText":"unsupported_notAvailableText___Ygw9"};